import packageJson from "../package.json";
import { parseDashboardEndpoints, resolveIndicatorEnvironment, resolveSentryEnvironment } from "./configuration";

// Centralized runtime configuration for the Doctor Dashboard frontend.
// All values can be overridden using Vite env variables (VITE_*).

const endpoints = parseDashboardEndpoints(import.meta.env);
export const CONFIGURATION_ERRORS = endpoints.errors;
export const ASSISTANT_UI_DEFAULT = import.meta.env.VITE_ASSISTANT_UI === 'openui' ? 'openui' : 'llama_index_ui_basic';
export const API_BASE_URL = endpoints.api;
export const HUB_BASE_URL = endpoints.hub;
export const LB_HOST = endpoints.lb;
export const AGENT_BASE_URL = endpoints.agent;
export const AUTH_BASE_URL = endpoints.auth;

// Allowed hosts (comma-separated)
export const ALLOWED_HOSTS = (import.meta.env.VITE_ALLOWED_HOSTS || '.fyn.rocks,localhost');

// Environment label
export const ENVIRONMENT = import.meta.env.VITE_ENVIRONMENT || import.meta.env.MODE || 'production';
export const DEV_MODE = import.meta.env.DEV || ENVIRONMENT === 'development';
const browserHost =
  typeof window === 'undefined' ? '' : window.location.hostname.toLowerCase();
export const INDICATOR_ENVIRONMENT = resolveIndicatorEnvironment(import.meta.env, browserHost);
export const DOCTOR_DASHBOARD_VERSION = packageJson.version;
export const SENTRY_RELEASE =
  import.meta.env.VITE_SENTRY_RELEASE ||
  `doctor-dashboard@${DOCTOR_DASHBOARD_VERSION}`;
export const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN || '';
export const SENTRY_ENVIRONMENT = resolveSentryEnvironment(import.meta.env, browserHost);
export const SENTRY_TRACES_SAMPLE_RATE = Number.parseFloat(
  import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE || '0.1',
);
const LOCAL_DASHBOARD_HOSTS = new Set(['localhost', '127.0.0.1', '::1']);
const isLocalDashboardHost =
  typeof window !== 'undefined' && LOCAL_DASHBOARD_HOSTS.has(browserHost);
export const DEV01_ADMIN_TOOLS_ENABLED =
  ENVIRONMENT.toLowerCase() === 'dev01' ||
  API_BASE_URL.toLowerCase().includes('dev01') ||
  HUB_BASE_URL.toLowerCase().includes('dev01') ||
  browserHost.includes('dev01');
export const LOCAL_AUTH_TESTING_ENABLED =
  import.meta.env.DEV &&
  isLocalDashboardHost &&
  import.meta.env.VITE_LOCAL_AUTH_TESTING === 'true';
export const LOCAL_AUTH_JWT_SECRET = LOCAL_AUTH_TESTING_ENABLED
  ? import.meta.env.VITE_LOCAL_AUTH_JWT_SECRET || 'local'
  : '';

// Google SSO configuration
export const GOOGLE_SSO = {
  // Google OAuth 2.0 / Identity Services Client ID
  clientId: import.meta.env.VITE_GOOGLE_CLIENT_ID || '',
};
